import { AccountswitchOptionsController } from './accountswitchOptions.controller';
import template from './accountswitchOptions.html';

export const confirmWarrantAccountswitchOptionsComponent = {
  name: 'confirmWarrantAccountswitchOptions',
  restrict: 'E',
  template,
  controller: AccountswitchOptionsController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '=',
    translatePrefix: '@',
  },
};
